'use client'

import React, { useEffect, useState } from 'react';
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from '@stripe/stripe-js';
import CheckoutForm from './CheckoutForm';
import { Flex } from '@radix-ui/themes';
import { Skeleton } from '../components/ui/skeleton';

const stripePromise = loadStripe(process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY!, {
  stripeAccount: process.env.NEXT_PUBLIC_STRIPE_CONNECTED_ACCOUNT_ID!,
});

interface Props {
  onNext: () => void;
  allowLaterSubmission?: boolean;
}

const StripeForm = ({
  onNext,
  allowLaterSubmission = true
}: Props) => {
  const [clientSecret, setClientSecret] = useState("");

  // Use dynamic values.
  useEffect(() => {
    // Create PaymentIntent as soon as the page loads
    fetch("/api/v1/verify/payment/setupIntent", {
      method: "POST",
    })
      .then((res) => res.json())
      .then((data) => setClientSecret(data.clientSecret));
  }, []);

  const options = {
    clientSecret
  };

  return (
    <Flex className="w-full rounded-sm">
      {clientSecret ? (
        <Elements key={clientSecret} options={options} stripe={stripePromise}>
          <CheckoutForm onNext={onNext} allowLaterSubmission={allowLaterSubmission} />
        </Elements>
      ) : (
        <Skeleton className="h-[360px] w-full mb-1" />
      )}
    </Flex>
  );
}

export default StripeForm

